import { Route } from 'react-router-dom';
import React from 'react';
import SetUpOnLineAccess from './views/SetUpOnLineAccess';
import ValidateRefCode from './views/ValidateRefCode';
import SystemError from './views/SystemError';
// import TimeOut from './views/TimeOut';

const { activeRule } = process.env;

export default [
  <Route
    exact path="/" key="/" render={() => <ValidateRefCode />}
  />,
  <Route
    exact path="/validateRefrenceCode" key="/validateRefrenceCode" render={() => <ValidateRefCode />}
  />,

  <Route
    exact path="/set-up-online/:slug" key="/set-up-online/:slug" render={({ match, history }) => {
      if (history.action === 'POP') {
        window.location.href = activeRule;
      } else {
        return <SetUpOnLineAccess />;
      }
      return true;
    }}
  />,
  <Route exact path="/error" component={SystemError} key="/system-error" />,

  // <Route exact path="/time-out" component={TimeOut} key="/time-out" />,

  // <Route
  //   key="/not-found" render={() => {
  //     // Redirect to lading page for any invalid url
  //     window.location.href = activeRule;
  //   }}
  // />,

];
